
















import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component
export default class List extends Vue {
    @Prop(Array) private data!: object[];

    @Emit('drillDwon')
    private onClick(val: any) {
        return val;
    }
}
